import styled, { RuleSet } from 'styled-components'
import React from 'react'
import { UIInfoSpace } from 'src/types/api'

const PaidNoticeText = ({
  NotiContent,
  notiCashSpace,
  $style,
}: Pick<UIInfoSpace.Response, 'NotiContent'> & {
  notiCashSpace: string
  $style?: RuleSet<object>
}) => {
  const { Text, FontSize, FontColor } = NotiContent
  return (
    <PaidNotiTextWrap
      $FontColor={FontColor}
      $FontSize={FontSize}
      $notiCashSpace={notiCashSpace}
      $style={$style}
    >
      <p dangerouslySetInnerHTML={{ __html: Text }} />
    </PaidNotiTextWrap>
  )
}

export default PaidNoticeText

const PaidNotiTextWrap = styled.div<{
  $FontSize: string
  $FontColor: string
  $notiCashSpace?: string
  $style?: RuleSet<object>
}>`
  width: 100%;
  text-align: center;
  margin-top: 20px;
  padding: 0 20px;

  p {
    white-space: break-spaces;
    /* color: ${({ $FontColor }) => $FontColor || 'var(--red-50)'}; */
    color: #f3223c;
    /* font-size: ${({ $FontSize }) => $FontSize || '16px'}; */
    font-size: 14px;
    line-height: 1.3;
    font-weight: 700;

  }
  ${(props) => props.$style};
`
